var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Instagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "60px",
    height: "60px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,105H40c-12.15,0-22-9.85-22-22V43c0-12.15,9.85-22,22-22h40c12.15,0,22,9.85,22,22v40 C102,95.15,92.15,105,80,105z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9500ba",
    d: "M80,18h-5.243h-7.476h-8.456H48.482C73.882,27.06,93.843,47.673,102,73.484V62.306v-8.845v-7.712 V40C102,27.85,92.15,18,80,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,45c-0.503,0-1,0.024-1.5,0.038v4C18.5,49.023,18.997,49,19.5,49C47.346,49,70,71.654,70,99.5 c0,0.838-0.023,1.672-0.063,2.5h4c0.038-0.829,0.063-1.662,0.063-2.5C74,69.449,49.551,45,19.5,45z",
    opacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7500",
    d: "M19.5,61c-0.503,0-1.002,0.019-1.5,0.038v4v4v4.007v4.011C18.496,77.023,18.995,77,19.5,77 C31.907,77,42,87.093,42,99.5c0,0.845-0.051,1.679-0.142,2.5h4.021h4.01h4.01h4.01c0.053-0.827,0.09-1.659,0.09-2.5 C58,78.271,40.729,61,19.5,61z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b730e1",
    d: "M48.482,18H40c-1.637,0-3.23,0.184-4.764,0.523c-2.568,0.567-4.965,1.583-7.11,2.961 c-1.599,1.028-3.059,2.253-4.339,3.648c-1.09,1.188-2.047,2.498-2.858,3.904C59.144,29.803,90,61.105,90,99.5 c0,0.032-0.002,0.063-0.002,0.095c1.407-0.719,2.728-1.581,3.94-2.574c1.418-1.162,2.686-2.499,3.776-3.976 c1.422-1.928,2.538-4.095,3.274-6.432C101.644,84.526,102,82.305,102,80v-6.516C93.843,47.673,73.882,27.06,48.482,18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49,18h-9c45,14,62,55.484,62,55.484C95.55,50.75,76,28,49,18z",
    opacity: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d663ff",
    d: "M20.93,29.036c-0.721,1.252-1.322,2.581-1.789,3.973c-0.433,1.292-0.749,2.637-0.936,4.024 C18.074,38.004,18,38.993,18,40v1.038v4C18.5,45.024,18.997,45,19.5,45C49.551,45,74,69.449,74,99.5 c0,0.838-0.026,1.671-0.063,2.5h4H80c0.654,0,1.299-0.034,1.939-0.09c1.38-0.121,2.723-0.369,4.019-0.733 c1.409-0.396,2.761-0.928,4.04-1.582c0-0.032,0.002-0.063,0.002-0.095C90,61.105,59.144,29.803,20.93,29.036z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.93,29.036c-0.721,1.252-1.322,2.581-1.789,3.973l0,0C19.261,33.007,19.38,33,19.5,33 c37.58,0,68.38,29.556,70.39,66.643c0.035-0.018,0.073-0.031,0.107-0.048c0-0.032,0.002-0.063,0.002-0.095 C90,61.105,59.144,29.803,20.93,29.036z",
    opacity: 0.35
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff1200",
    d: "M19.5,45c-0.503,0-1,0.024-1.5,0.038v4v4v4v4C18.498,61.019,18.997,61,19.5,61 C40.729,61,58,78.271,58,99.5c0,0.841-0.037,1.673-0.09,2.5h4.01h4.01h4.006h4c0.038-0.829,0.063-1.662,0.063-2.5 C74,69.449,49.551,45,19.5,45z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.949,101.5c0.026-0.665,0.051-1.329,0.051-2C74,69.449,49.551,45,19.5,45 c-0.503,0-1,0.024-1.5,0.038v4C18.5,49.024,18.997,49,19.5,49C48.881,49,72.892,72.373,73.949,101.5z",
    opacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.935,101.321C57.966,100.716,58,100.112,58,99.5C58,78.271,40.729,61,19.5,61 c-0.503,0-1.002,0.019-1.5,0.038v4C18.498,65.019,18.997,65,19.5,65C39.997,65,56.8,81.102,57.935,101.321z",
    opacity: 0.35
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M19.5,77c-0.505,0-1.004,0.023-1.5,0.056V80c0,0.36,0.01,0.719,0.027,1.075 c0.526,10.926,9.021,19.761,19.8,20.818C38.542,101.962,39.267,102,40,102h1.858c0.091-0.821,0.142-1.655,0.142-2.5 C42,87.093,31.907,77,19.5,77z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,81c11.72,0,21.37,9.008,22.403,20.462c0.057-0.648,0.097-1.3,0.097-1.962 C42,87.093,31.907,77,19.5,77c-0.505,0-1.004,0.023-1.5,0.056V80c0,0.354,0.01,0.705,0.027,1.055C18.514,81.023,19.004,81,19.5,81 z",
    opacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 64,
    r: 13.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 13.5,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 48,
    r: 4,
    opacity: 0.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 44,
    r: 4,
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M75.1,91.5H44.9 c-6.848,0-12.4-5.552-12.4-12.4V48.9c0-6.848,5.552-12.4,12.4-12.4h30.2c6.848,0,12.4,5.552,12.4,12.4v30.2 C87.5,85.948,81.948,91.5,75.1,91.5z",
    opacity: 0.35
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M75.1,87.5H44.9c-6.848,0-12.4-5.552-12.4-12.4 V44.9c0-6.848,5.552-12.4,12.4-12.4h30.2c6.848,0,12.4,5.552,12.4,12.4v30.2C87.5,81.948,81.948,87.5,75.1,87.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram);
export default __webpack_public_path__ + "static/media/icons8-instagram.c64da42fe3928b2978af81686ee761b7.svg";
export { ForwardRef as ReactComponent };